/** Getting in and finding: language choice, sign-in, the menu, Find, My card, the job list. */
export const screens = {
    "onboard.title": "Choose your language",
    "onboard.later": "You can change it later in About me.",
    "onboard.continue": "Continue",
    "signin.label": "Sign in",
    "signin.headline": "Your agent, your phone.",
    "signin.soft": "Your number stays yours.",
    "signin.consumer": "I need work done",
    "signin.worker": "I do the work",
    "signin.language": "Language: {lang}",
    "signin.change": "Change",
    "signin.name": "Your name",
    "signin.phone": "Mobile number",
    "signin.err_phone": "Enter your 10-digit mobile number.",
    "signin.code": "Code from SMS",
    "signin.code_dev": "Code from SMS (dev: {code})",
    "signin.send_code": "Send code",
    "signin.submit": "Sign in",
    "role.worker": "worker",
    "role.customer": "customer",
    "nav.find": "Find",
    "nav.my_jobs": "My jobs",
    "nav.card": "My card",
    "shell.sign_out": "Sign out",
    "trail.to_decide": "{count} to decide",
    "find.headline": "Who can help, near you.",
    "find.soft": "Your budget stays on this phone.",
    "find.area": "Area",
    "find.within_km": "within {km} km",
    "find.distance": "{km} km",
    "find.from": "from {price}",
    "find.when": "When",
    "find.ask.one": "Ask {count} worker",
    "find.ask.other": "Ask {count} workers",
    "card.headline": "Be found.",
    "card.soft": "Your lowest price stays on this phone.",
    "card.what": "What I do",
    "card.where": "Where I work",
    "card.rate": "Usual rate, ₹ (shown on the board)",
    "card.min": "Lowest I will take, ₹ (private)",
    "card.about": "About my work",
    "card.about_example": "10 years, wiring and fans",
    "card.languages": "Languages I speak",
    "card.ask_first": "Ask me before quoting when there are {item}",
    "card.auto": "Let my agent sign deals inside my prices",
    "card.band_use": "Your agent plans each job from this range and never goes below your lowest price.",
    "card.on_board": "On the board: {trades} in {area} from {price}",
    "card.off_board": "Off the board",
    "card.publish": "Publish my card",
    "card.unlist": "Take my card off the board",
    "card.err_trade": "Choose at least one trade, or add your own work.",
    "card.err_rate": "Your usual rate must be at least your lowest rate.",
    "requests.checked": "Checked {time}",
    "error.generic": "Something went wrong. Please try again.",
    "a11y.deal": "Deal",
    "a11y.contact": "Contact",
    "a11y.notes": "Notes",
    "a11y.payment": "Payment",
    "a11y.plan": "Plan",
    "a11y.approve": "Approve the request",
    "a11y.answer": "Answer the worker",
    "a11y.sign": "Sign the deal",
    "a11y.confirm_payment": "Confirm payment",
    "a11y.pay": "Pay",
    "a11y.review": "Review",
    "a11y.stars": "Stars",
    "a11y.review_text": "Review text",
    "a11y.utr": "UPI reference",
    "a11y.qr": "UPI QR code",
    "a11y.job_with": "Job with {name}",
    "a11y.worker": "Worker {name}",
    "a11y.ask_worker": "Ask {name}",
    "a11y.ask_workers": "Ask workers",
    "a11y.my_card": "My card",
    "a11y.role": "Role",
    "a11y.language": "Language",
    "a11y.note": "Note to the customer",
    "a11y.send": "Send",
};
//# sourceMappingURL=screens.js.map